// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="rating_arena.PowerGainPerSeason"></bfg-chart>
    </div>
</div>

<rating-arena-season-table api-method="power_gain_table"></rating-arena-season-table>
`;
// Exports
module.exports = code;